import { create } from "zustand";
import { persist } from "zustand/middleware";

type SectionsStore = {
    dismissedSections: string[];
    dismissSection: (dossierId: string) => void;
};

export const useSectionsStore = create<SectionsStore>()(
    persist(
        (set) => ({
            dismissedSections: [],
            dismissSection: (dossierId: string) => {
                set((state) => ({
                    dismissedSections: [...state.dismissedSections, dossierId],
                }));
            },
        }),
        { name: "sections-state" }
    )
);
